import React from "react";
import { Link } from "react-router-dom";
import { ProductConsumer } from "../context";
import { ButtonContainer } from "./styles/ButtonContainer";

export default function Details() {
  return (
    <ProductConsumer>
      {({ detailProduct, addToCart, openModal }) => {
        const { id, company, img, info, price, title, inCart } =
          detailProduct || {};

        return (
          <div className="container py-5">
            {/* Product title */}
            <div className="row">
              <div className="col-10 mx-auto text-center text-slanted text-blue my-5">
                <h1>{title}</h1>
              </div>
            </div>
            {/* Product info */}
            <div className="row">
              <div className="col-10 mx-auto col-md-6 my-3 text-capitalize">
                <img src={img} alt={title} className="img-fluid" />
              </div>
              <div className="col-10 mx-auto col-md-6 my-3 text-capitalize">
                <p>model : {title}</p>
                <p className="text-title text-uppercase text-muted mt-3 mb-2">
                  made by : <span className="text-uppercase">{company}</span>
                </p>
                <p className="text-blue">
                  <strong>
                    price : <span>$</span> {price}
                  </strong>
                </p>
                <p className="text-capitalize font-weight-bold">
                  some info about product
                </p>
                <p className="text-muted">{info}</p>
                {/* Buttons */}
                <div className="d-flex flex-wrap">
                  <Link to="/">
                    <ButtonContainer>back to products</ButtonContainer>
                  </Link>

                  <ButtonContainer
                    cart
                    disabled={inCart ? true : false}
                    onClick={() => {
                      addToCart(id);
                      openModal(id);
                    }}
                  >
                    {inCart ? "in Cart" : "Add to cart"}
                  </ButtonContainer>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </ProductConsumer>
  );
}
